import MUITabs from '@material-ui/core/Tabs';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { color } from '../../app/theme';
import Tab from './Tab';

const styles = makeStyles(
  {
    root: {
      borderBottom: `1px solid ${color.$9}`,
    },
    tabs: {
      width: '100%',
      padding: '0 24px',
      backgroundColor: color.$7,
    },
    flexContainer: {
      height: 47,
    },
    indicator: {
      backgroundColor: color.$3,
    },
    title: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    badge: {
      width: '8px',
      height: '8px',
      backgroundColor: color.$16,
      borderRadius: '100%',
      marginLeft: '6px',
    },
  },
  {
    name: 'Tabs',
  },
);

const Tabs = props => {
  const { className, tabs, ...others } = props;
  const classes = styles();
  const createTabs = () =>
    tabs.map(
      (tab, index) =>
        !tab.isHide && (
          <Tab
            key={tab.key}
            label={
              <div className={classes.title}>
                {tab.name}
                {tab.isNeedUpdate && <div className={classes.badge} />}
              </div>
            }
            id={`tab-${index}`}
            aria-controls={`tabpanel-${index}`}
            disabled={tab.disabled}
          />
        ),
    );

  return (
    <MUITabs
      className={classnames(classes.tabs, className)}
      classes={{
        root: classes.root,
        indicator: classes.indicator,
        flexContainer: classes.flexContainer,
      }}
      {...others}
    >
      {createTabs()}
    </MUITabs>
  );
};

export default Tabs;
